import { render, staticRenderFns } from "./ueditor.vue?vue&type=template&id=72299a88&scoped=true"
import script from "./ueditor.vue?vue&type=script&lang=js"
export * from "./ueditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72299a88",
  null
  
)

export default component.exports